export const FormSuccessModalViewTestId = 'FormSuccessModalView';
export const defaultSubHeadline = `We've received your request!`;
export const defaultContent =
    'We will reach out soon to schedule a time to review the project details. In the meantime, please check out projects on some of our previous projects.';
export const defaultBtnText = 'Projects';
export const defaultBtnUrl = `/project`;
